import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var Page = _ref => {
  var {
    children,
    theme
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    "data-theme": theme,
    children: children
  });
};
//# sourceMappingURL=page.js.map